import React, { useEffect, useState, useContext } from "react";
import appConst from "../Utilities/appConst.json";
import "../styles/summary.css";
import Accordion from "../shared/Accordion";
import { LanguageContext } from "../context/language/LanguageContext";
import SummaryBasketItems from "./SummaryBasketItems";
import { ChevronDown } from "lucide-react";
import { getLanguageDirection } from "../Utilities/languageDirection";

const SummaryBasketItemsAccordion = () => {
  const languageContext = useContext(LanguageContext);
  const direction = getLanguageDirection(languageContext?.language?.id);

  return (
    <div
      className="background_nyanza background_white"
      data-testid="summary-basket-items-accordion"
    >
      <Accordion
        icon={<ChevronDown size={20} />}
        iconColor="color_green"
        accordionSummary={
          <div
            className="color_black_olive text-sm sm:text-lg"
            data-testid="summary-basket-items-accordion-title"
            style={{
              direction,
              width: "100%",
              fontFamily: "Lupa PLONI MEDIUM",
              textAlign: "start",
            }}
          >
            {languageContext.getTranslation(
              appConst.ACCORDION_BUTTON_TEXT_OPEN
            )}
          </div>
        }
        accordionDetails={
          <SummaryBasketItems
            note={languageContext.getTranslation(appConst.APPSALE_NOTE)}
          />
        }
      />
    </div>
  );
};
export default SummaryBasketItemsAccordion;
